<div class="row">
    <div class="col">
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Vat</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let country of countriesList">
                        <td scope="row">{{country.id}}</td>
                        <td>{{country.name}}</td>
                        <td>
                            {{country.vat}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>